<template>
  <div>
    <v-container>
      <v-layout wrap class="pt-4">
        <v-flex xs12 sm6 class="text-sm-left text-xs-left">
          <importxlsx :loading="importloading" @onChange="onImportStaff" :noraw="true"></importxlsx>
          <v-btn dark outline color="primary" @click="downloadImportTemplate">
            <em class="fas fa-download" />&nbsp;Download template
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <v-btn depressed color="primary" @click="showSearch = true" class="ma-0 mr-1">
            <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
          </v-btn>
          <v-btn dark outline color="primary" @click="getXlsxData" :loading="loading">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="employeeData"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.staffid }}</td>
            <td>{{ props.item.fname }}</td>
            <td>{{ props.item.lname }}</td>
            <td>{{ props.item.dob | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.gender == 'M' ? 'Male' : 'Female' }}</td>
            <td>{{ props.item.affiliation || '-' }}</td>
            <td>{{ props.item.position || '-' }}</td>
            <td>{{ props.item.division || '-' }}</td>
            <td>{{ props.item.department }}</td>
            <td>{{ props.item.hire_date | DateFormat('DD/MM/YYYY') }}</td>
            <td>
              <v-select
                v-model="props.item.status"
                @change="onUpdateStatus(props.item, $event)"
                :items="statusMasterData"
                item-text="engname"
                item-value="engname"
                solo
                hide-details
              ></v-select>
            </td>
            <td>{{ props.item.probation_level || '-' }}</td>
            <td>{{ props.item.sop || '-' }}</td>
            <td>{{ props.item.headman || '-' }}</td>
            <td>
              <change-password v-model="props.item.staffid" @success="reset"></change-password>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <v-dialog v-model="showSearch" persistent width="850px">
        <SearchEmployeeDialog
          @close="onCloseSearch"
          @onSearch="onSearch"
          :statusMasterData="statusMasterData"
          :divisionMasterData="divisionMasterData"
          :departmentMasterData="departmentMasterData"
          :affiliationMasterData="affiliationMasterData"
          :positionMasterData="positionMasterData"
        ></SearchEmployeeDialog>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import hopinnHrApi from '@/api/hopinn-hr'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import importxlsx from '@/components/elements/importxlsx.vue'
import SearchEmployeeDialog from './SearchEmployeeDialog.vue'
import ChangePassword from './ChangePassword.vue'
import moment from 'moment'

export default {
  props: [
    'statusMasterData',
    'divisionMasterData',
    'departmentMasterData',
    'affiliationMasterData',
    'positionMasterData'
  ],
  components: {
    importxlsx,
    SearchEmployeeDialog,
    ChangePassword
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      showDetail: false,
      showSearch: false,
      loading: false,
      employeeData: [],
      filter: {},
      headers: [
        { text: 'Staff ID', value: 'staffid' },
        { text: 'First name', value: 'fname' },
        { text: 'Last name', value: 'lname' },
        { text: 'Date of Birth', value: 'dob' },
        { text: 'Gender', value: 'gender' },
        { text: 'สังกัด', value: 'affiliation' },
        { text: 'ตำแหน่ง', value: 'postion' },
        { text: 'Division', value: 'division' },
        { text: 'แผนก', value: 'department' },
        { text: 'Hire date', value: 'hire_date' },
        { text: 'Status', value: 'status' },
        { text: 'Probation level', value: 'probation_level' },
        { text: 'SOP Pass/Fail', value: 'sop' },
        { text: 'หัวหน้าพนักงาน', value: 'headman' },
        { text: 'Password', value: 'tags' }
      ],
      tags: [],
      currentStaffStatus: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getStaffList()
  },
  methods: {
    showItemDetail(item) {
      this.detail = {
        userid: item.userid,
        card_id: item.card_id
      }
      this.showDetail = true
    },
    onSearch(payload) {
      this.filter = payload
      this.showSearch = false
      this.reset()
    },
    onCloseSearch() {
      this.showSearch = false
    },
    async onImportStaff(item) {
      const vm = this
      try {
        const data = {
          pageid: this.selectedBot.pageid,
          data_import: item[0]
        }

        vm.importloading = true
        const response = await hopinnHrApi.importStaff({ data })
        vm.importloading = false

        if (response && response.data.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.reset()
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    downloadImportTemplate() {
      const data = []
      const heading = [
        [
          'Staff ID',
          'First name',
          'Last name',
          'Date of Birth',
          'Gender',
          'Affiliation',
          'Position',
          'Division',
          'Department',
          'Hiring date',
          'Status',
          'Probation level',
          'SOP Pass/Fail',
          'Supervisor'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, data)
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `template-import-employee.xlsx`)
    },
    async getXlsxData() {
      const vm = this
      vm.isExport = true
      const data = await vm.getStaffList()
      vm.isExport = false
      vm.getStaffList()

      if (data == null) return
      const employees = data.map((el) => {
        return {
          staffid: el.staffid,
          fname: el.fname,
          lname: el.lname,
          dob: el.dob ? moment(el.dob).format('DD/MM/YYYY') : '',
          gender: el.gender,
          affiliation: el.affiliation ? el.affiliation : '-',
          position: el.position ? el.position : '-',
          division: el.division ? el.division : '-',
          department: el.department ? el.department : '-',
          hire_date: el.hire_date ? moment(el.hire_date).format('DD/MM/YYYY') : '',
          status: el.status ? el.status : '-',
          probation_level: el.probation_level ? el.probation_level : '-',
          sop: el.sop ? el.sop : '-',
          headman: el.headman ? el.headman : '-'
        }
      })

      const heading = [
        [
          'Staff ID',
          'First name',
          'Last name',
          'Date of Birth',
          'Gender',
          'Affiliation',
          'Position',
          'Division',
          'Department',
          'Hiring date',
          'Status',
          'Probation level',
          'SOP Pass/Fail',
          'Supervisor'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, employees, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `hopinn-employee-list.xlsx`)
    },
    async getStaffList() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          pageid: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        if (this.filter.staff_id) {
          Object.assign(data, { staffid: this.filter.staff_id })
        }
        if (this.filter.first_name) {
          Object.assign(data, { fname: this.filter.first_name })
        }
        if (this.filter.last_name) {
          Object.assign(data, { lname: this.filter.last_name })
        }
        if (this.filter.department) {
          Object.assign(data, { department: this.filter.department.engname })
        }
        if (this.filter.affiliation) {
          Object.assign(data, { affiliation: this.filter.affiliation.engname })
        }
        if (this.filter.status) {
          Object.assign(data, { status: this.filter.status.engname })
        }
        if (this.filter.probation_level) {
          Object.assign(data, { probation_level: this.filter.probation_level })
        }
        if (this.filter.sop_status) {
          Object.assign(data, { sop: this.filter.sop_status })
        }

        vm.loading = true
        const response = await hopinnHrApi.getStaffList({
          config: {
            params: data
          }
        })

        vm.loading = false
        if (response && response.data.responsecode == 200) {
          vm.employeeData = response.data.data
          vm.total = response.data.total

          const responseData = response.data.data
          let tempCurrentStaffStatus = []
          if (responseData) {
            responseData.forEach((item) => {
              tempCurrentStaffStatus.push({
                staffid: item.staffid,
                status: item.status
              })
            })
          }
          if (tempCurrentStaffStatus) vm.currentStaffStatus = tempCurrentStaffStatus
          resolve(response.data.data)
        } else {
          reject(null)
        }
      })
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.getStaffList()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.getStaffList()
    },
    onUpdateStatus(item, status) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการเปลี่ยน Status ใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.updateStatusByStaff(item, status)
          }
        })
    },
    async updateStatusByStaff(item, status) {
      const vm = this
      try {
        let data = {
          pageid: vm.selectedBot.pageid,
          staffid: item.staffid,
          status: status,
          department: item.department,
          affiliation: item.affiliation
        }

        const currentStatus = vm.currentStaffStatus
        let oldStatus = ''
        if (currentStatus) {
          let result = currentStatus.find((val) => {
            return item.staffid == val.staffid
          })
          if (result) oldStatus = result.status
        }

        Object.assign(data, { oldStatus: oldStatus })

        const response = await hopinnHrApi.updateStatusStaff({ data })
        if (response && response.data.responsecode == 200) {
          vm.$swal.fire({
            text: 'เปลี่ยน Status เรียบร้อย',
            type: 'success'
          })
        }
      } catch (error) {
        console.error(err)
        return
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/EmployeeList.vue